var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 101,
    viewBox: "0 0 102 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 48097534"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1253",
    cx: 51.1094,
    cy: 50.5,
    r: 50.5,
    fill: "#9AD450"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M45.8029 58.6689L38.0053 50.1824C37.6322 49.7765 37.1262 49.5484 36.5986 49.5484C36.071 49.5484 35.565 49.7765 35.1919 50.1824C34.8189 50.5885 34.6094 51.1392 34.6094 51.7134C34.6094 52.2876 34.8189 52.8383 35.1919 53.2444L42.9895 61.7309C43.359 62.1332 43.7978 62.4524 44.2807 62.6702C44.7636 62.8879 45.2812 63 45.8039 63C46.3266 63 46.8442 62.8879 47.3271 62.6702C47.81 62.4524 48.2488 62.1332 48.6183 61.7309L67.0268 41.696C67.3998 41.2899 67.6094 40.7392 67.6094 40.165C67.6094 39.5908 67.3998 39.0401 67.0268 38.634C66.6537 38.2281 66.1477 38 65.6201 38C65.0925 38 64.5865 38.2281 64.2134 38.634L45.8029 58.6689Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.817b40e70da2b4a8d4b8d219b6ca8ea3.svg";
export { ForwardRef as ReactComponent };